import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from './ui/input';
import { Button } from './ui/button';

const NEW = '__new__';

export const HookTypeSelect = ({ value, types, onChange, onAddType, testId, noun = 'tipo' }) => {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const add = async () => {
    const n = name.trim();
    if (!n) return;
    try { await onAddType(n); onChange(n); setAdding(false); setName(''); toast.success(`${noun[0].toUpperCase()}${noun.slice(1)} «${n}» añadido`); } catch (e) { toast.error(e.message); }
  };
  if (adding) {
    return (
      <div className="flex gap-1">
        <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } if (e.key === 'Escape') { e.stopPropagation(); setAdding(false); } }} placeholder={`Nuevo ${noun}`} className="h-9" data-testid={`${testId}-new-input`} />
        <Button size="icon" className="h-9 w-9 shrink-0" onClick={add} data-testid={`${testId}-new-save`}><Plus className="w-4 h-4" /></Button>
      </div>
    );
  }
  return (
    <select value={value} onChange={(e) => (e.target.value === NEW ? setAdding(true) : onChange(e.target.value))} className="h-9 w-full rounded-md border px-2 text-sm bg-background" data-testid={testId}>
      <option value="">Sin {noun}</option>
      {types.map((t) => <option key={t} value={t}>{t}</option>)}
      <option value={NEW}>+ Añadir {noun} nuevo…</option>
    </select>
  );
};
